import { FC } from 'react';

import { Typography } from '@beeline/design-system-react/extracted-styles';
import { Link } from '@beeline/lk-utils';

import { Column } from 'src/components/Column/Column';
import { Truncate } from 'src/components/Truncate/Truncate';

import { BookingCardComponentProps } from '../types';

import classes from './DesktopBookingCard.module.scss';

export const DesktopBookingCard: FC<BookingCardComponentProps> = ({
  link,
  title,
  place,
  date,
  time,
}) => {
  return (
    <div className={classes.container}>
      <div className={classes.columns}>
        <div className={classes.title}>
          <div className={classes.linkContainer}>
            {link ? (
              <Link
                navigationType='inner'
                to={link}
                className={classes.link}
                data-testid='bookingTitle'
              >
                {title}
              </Link>
            ) : (
              <Typography variant='body3' ellipsis>
                {title}
              </Typography>
            )}
          </div>
        </div>
        <Column
          title='Место бронирования'
          content={<Truncate variant='body3'>{place}</Truncate>}
          className={classes.place}
          testId='bookingPlace'
        />
        <Column
          title='Дата'
          content={<Truncate variant='body3'>{date}</Truncate>}
          className={classes.date}
          testId='bookingDate'
        />
        {time && (
          <Column
            title='Время'
            content={<Truncate variant='body3'>{time}</Truncate>}
            className={classes.time}
            testId='bookingTime'
          />
        )}
      </div>
    </div>
  );
};
